// extracted by mini-css-extract-plugin
export var fadeInOut = "_l-3";
export var icon = "_l-4";
export var savedIndicator = "_l-2";
export var savingIndicator = "_l-0";
export var spin = "_l-1";